// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UploadFileLoading_uploadStatus__P7e6h {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background-color: var(--color-neutral-100);
    color: var(--color-neutral-900);
    border-radius: var(--radius-global);
    border: 1px solid var(--color-neutral-400);
    padding: 24px 40px;
}

.UploadFileLoading_uploadStatus__P7e6h img {
    width: 80%;
}

.UploadFileLoading_uploadStatusContent__2JBF4 {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
}

.UploadFileLoading_timerFarme__El-Cb {
    position: relative;
    width: 100%;
    height: 16px;
    border: 1px solid var(--color-neutral-900);
    background-color: var(--color-neutral-000);
    border-radius: var(--radius-global);
    direction: ltr;
}

.UploadFileLoading_timer__gjq5t {
    width: 0%;
    height: 100%;
    background-color: var(--color-primary);
    border-radius: var(--radius-global);
    transition: width 0.01s
}

.UploadFileLoading_messageBox__Oghl6 {
    width: 100%;
    display: flex;
    gap: 16px;
    background-color: var(--color-neutral-200);
    color: var(--color-neutral-900);
    border: 1px solid var(--color-neutral-500);
    border-radius: var(--radius-global);
    padding: 16px;
}



.UploadFileLoading_uploadInformation__3INtX {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 16px;
}

.UploadFileLoading_uploadPreview__NbgIt {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: var(--color-neutral-100);
    color: var(--color-neutral-900);
    border-radius: var(--radius-global);
    border: 1px solid var(--color-neutral-400);
    padding: 24px 40px;
    gap: 24px;
}

.UploadFileLoading_uploadPreview__NbgIt > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}


.UploadFileLoading_uploadPreviewController__ApXbh {
    display: flex;
    flex-wrap: wrap;
    gap: 40px;
}

.UploadFileLoading_uploadPreviewController__ApXbh svg {
    width: 24px;
    height: 24px;
}

.UploadFileLoading_uploadMessage__m-N95 {
    width: 100%;
    background-color: var(--color-neutral-100);
    color: var(--color-neutral-900);
    border-radius: var(--radius-global);
    border: 1px solid var(--color-neutral-400);
    padding: 24px 40px;
    height: 200px;

}

.UploadFileLoading_uploadMessageTitle__xuOCp {
    font-size: 1.1rem;
    color: var(--color-neutral-900);
}

.UploadFileLoading_uploadMessageDescription__8fHsC {
    font-size: 0.8rem;
    color: var(--color-neutral-900);
}

.UploadFileLoading_uploadMessageBtn__pVeDG {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 8px;
    font-size: 1rem;
    background-color: var(--color-primary);
    color: var(--color-white) !important;
    border-radius: var(--radius-global);
    gap: 4px;
    margin-top: 16px;
}


@media screen and (min-width : 992px) {
    .UploadFileLoading_uploadStatus__P7e6h {
        width: calc(45% - 8px);
    }

    .UploadFileLoading_uploadInformation__3INtX {
        width: calc(55% - 8px);
    }
}`, "",{"version":3,"sources":["webpack://./src/Styles/UploadFile/UploadFileLoading.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,0CAA0C;IAC1C,+BAA+B;IAC/B,mCAAmC;IACnC,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,0CAA0C;IAC1C,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,sCAAsC;IACtC,mCAAmC;IACnC;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,SAAS;IACT,0CAA0C;IAC1C,+BAA+B;IAC/B,0CAA0C;IAC1C,mCAAmC;IACnC,aAAa;AACjB;;;;AAIA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,0CAA0C;IAC1C,+BAA+B;IAC/B,mCAAmC;IACnC,0CAA0C;IAC1C,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;;AAGA;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,0CAA0C;IAC1C,+BAA+B;IAC/B,mCAAmC;IACnC,0CAA0C;IAC1C,kBAAkB;IAClB,aAAa;;AAEjB;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sCAAsC;IACtC,oCAAoC;IACpC,mCAAmC;IACnC,QAAQ;IACR,gBAAgB;AACpB;;;AAGA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":[".uploadStatus {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    background-color: var(--color-neutral-100);\n    color: var(--color-neutral-900);\n    border-radius: var(--radius-global);\n    border: 1px solid var(--color-neutral-400);\n    padding: 24px 40px;\n}\n\n.uploadStatus img {\n    width: 80%;\n}\n\n.uploadStatusContent {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n}\n\n.timerFarme {\n    position: relative;\n    width: 100%;\n    height: 16px;\n    border: 1px solid var(--color-neutral-900);\n    background-color: var(--color-neutral-000);\n    border-radius: var(--radius-global);\n    direction: ltr;\n}\n\n.timer {\n    width: 0%;\n    height: 100%;\n    background-color: var(--color-primary);\n    border-radius: var(--radius-global);\n    transition: width 0.01s,\n}\n\n.messageBox {\n    width: 100%;\n    display: flex;\n    gap: 16px;\n    background-color: var(--color-neutral-200);\n    color: var(--color-neutral-900);\n    border: 1px solid var(--color-neutral-500);\n    border-radius: var(--radius-global);\n    padding: 16px;\n}\n\n\n\n.uploadInformation {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    gap: 16px;\n}\n\n.uploadPreview {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background-color: var(--color-neutral-100);\n    color: var(--color-neutral-900);\n    border-radius: var(--radius-global);\n    border: 1px solid var(--color-neutral-400);\n    padding: 24px 40px;\n    gap: 24px;\n}\n\n.uploadPreview > img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n\n.uploadPreviewController {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 40px;\n}\n\n.uploadPreviewController svg {\n    width: 24px;\n    height: 24px;\n}\n\n.uploadMessage {\n    width: 100%;\n    background-color: var(--color-neutral-100);\n    color: var(--color-neutral-900);\n    border-radius: var(--radius-global);\n    border: 1px solid var(--color-neutral-400);\n    padding: 24px 40px;\n    height: 200px;\n\n}\n\n.uploadMessageTitle {\n    font-size: 1.1rem;\n    color: var(--color-neutral-900);\n}\n\n.uploadMessageDescription {\n    font-size: 0.8rem;\n    color: var(--color-neutral-900);\n}\n\n.uploadMessageBtn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    padding: 8px;\n    font-size: 1rem;\n    background-color: var(--color-primary);\n    color: var(--color-white) !important;\n    border-radius: var(--radius-global);\n    gap: 4px;\n    margin-top: 16px;\n}\n\n\n@media screen and (min-width : 992px) {\n    .uploadStatus {\n        width: calc(45% - 8px);\n    }\n\n    .uploadInformation {\n        width: calc(55% - 8px);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"uploadStatus": `UploadFileLoading_uploadStatus__P7e6h`,
	"uploadStatusContent": `UploadFileLoading_uploadStatusContent__2JBF4`,
	"timerFarme": `UploadFileLoading_timerFarme__El-Cb`,
	"timer": `UploadFileLoading_timer__gjq5t`,
	"messageBox": `UploadFileLoading_messageBox__Oghl6`,
	"uploadInformation": `UploadFileLoading_uploadInformation__3INtX`,
	"uploadPreview": `UploadFileLoading_uploadPreview__NbgIt`,
	"uploadPreviewController": `UploadFileLoading_uploadPreviewController__ApXbh`,
	"uploadMessage": `UploadFileLoading_uploadMessage__m-N95`,
	"uploadMessageTitle": `UploadFileLoading_uploadMessageTitle__xuOCp`,
	"uploadMessageDescription": `UploadFileLoading_uploadMessageDescription__8fHsC`,
	"uploadMessageBtn": `UploadFileLoading_uploadMessageBtn__pVeDG`
};
export default ___CSS_LOADER_EXPORT___;
